import { observable } from 'mobx'
import ResourcesStore from '../ResourcesStore'
import { ResourcesRequest } from '../ResourcesRequest'

class RenameDocumentStore {
  @observable isLoading = false

  rename = async (newName, objectId) => {
    this.isLoading = true

    await ResourcesRequest.rename(objectId, newName)

    this.isLoading = false

    ResourcesStore.search()
  }

  clearStore = () => {
    this.isLoading = false
  }
}

export default new RenameDocumentStore()
